import {
  SelectContent,
  SelectField,
  SelectItem,
} from "@ps-design-system/components/Select";

import { useIntl } from "react-intl-compat";

import { ROOM_TYPES } from "../../ListingFsvForm.consts";

import {
  ROOM_TYPE_DESCRIPTIONS,
  ROOM_TYPE_LABELS,
} from "./RoomTypeField.consts";

/** The FSV room type select. */
const RoomTypeField = () => {
  const intl = useIntl();

  return (
    <div className="tw-mb-16">
      <SelectField
        fullWidth
        name="roomType"
        label={intl.formatMessage({
          id: "hosting.listing_fsv.room_type_label",
          defaultMessage: "Room type",
        })}
        subcopy={intl.formatMessage({
          id: "hosting.listing_fsv.room_type_description",
          defaultMessage: "How much of your venue is included at these rates.",
        })}
        testId="fsv-form-room-type-select"
        renderContent={() => (
          <SelectContent>
            {ROOM_TYPES.map((roomType) => (
              <SelectItem key={roomType} value={roomType}>
                <span className="tw-block">
                  {intl.formatMessage(ROOM_TYPE_LABELS[roomType])}
                </span>
                {/* SelectItem has no description prop, and the trigger (a
                    button) mirrors the item's content; keep it to the label */}
                <span
                  className="tw-block tw-caption-2 tw-text-gray-600 [button_&]:tw-hidden"
                  data-testid={`fsv-form-room-type-${roomType}-description`}
                >
                  {intl.formatMessage(ROOM_TYPE_DESCRIPTIONS[roomType])}
                </span>
              </SelectItem>
            ))}
          </SelectContent>
        )}
      />
    </div>
  );
};

export { RoomTypeField };
